import Vue from 'vue'
import Vuex from 'vuex'
import * as Sentry from '@sentry/browser'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentBaseline: null,
    currentBaselinePage: 'baseline-explorer',
    currentItem: null,
    currentProject: null,
    currentTab: null,
    needToRefreshItemsList: false,
    needToRefreshFolderDetail: false,
    needToRefreshRequirementsDetail: false,
    needToRefreshBaselineList: false,
    openFolderIds: {},
    projects: {},
    projectsArray: [],
    selectedFolder: null,
    selectedRequirements: []
  },
  mutations: {
    addOpenFolder (state, payload) {
      Vue.set(state.openFolderIds, payload)
    },
    deleteOpenFolder (state, payload) {
      Vue.delete(state.openFolderIds, payload)
    },
    clearOpenFolders (state, payload) {
      state.openFolderIds = {}
    },
    addSelectedRequirement (state, payload) {
      state.selectedRequirements = state.selectedRequirements.concat(payload)
    },
    clearSelectedRequirements (state, payload) {
      state.selectedRequirements = []
    },
    deleteSelectedRequirement (state, payload) {
      state.selectedRequirements.splice(state.selectedRequirements.findIndex(x => x === payload), 1)
    },
    setCurrentBaseline (state, payload) {
      state.currentBaseline = payload
    },
    setCurrentBaselinePage (state, payload) {
      state.currentBaselinePage = payload
    },
    setCurrentItem (state, payload) {
      state.currentItem = payload
    },
    setCurrentProject (state, payload) {
      state.currentProject = payload
    },
    setCurrentTab (state, payload) {
      state.currentTab = payload
    },
    setNeedToRefreshItemsList (state, payload) {
      state.needToRefreshItemsList = payload
    },
    setNeedToRefreshFolderDetail (state, payload) {
      state.needToRefreshFolderDetail = payload
    },
    setNeedToRefreshRequirementsDetail (state, payload) {
      state.needToRefreshRequirementsDetail = payload
    },
    setNeedToRefreshBaselineList (state, payload) {
      state.needToRefreshBaselineList = payload
    },
    setProjects (state, payload) {
      state.projects = payload
    },
    setProjectsArray (state, payload) {
      state.projectsArray = payload
    },
    setSelectedFolder (state, payload) {
      // This is the folder destination for the "move folder"/"move requirement" process
      state.selectedFolder = payload
    }
  },
  actions: {
    refreshProjects ({ commit }) {
      // This one is reached when refreshing the page and when it has e.g. 10400-requirements
      // or entering the app for the first time
      const globalProjectId = 0
      const globalProjectName = 'Global Requirements'
      const globalProject = {id: globalProjectId, name: globalProjectName}
      const projectLookup = {}
      const projectsArray = []
      const getProjectData = (startAt = 0, maxResults = 50) => {
        window.AP.request({
          url: `/rest/api/3/project/search?startAt=${startAt}&maxResults=${maxResults}`,
          success: response => {
            const data = JSON.parse(response)
            data.values.forEach(i => {
              projectLookup[i.id] = i
              projectsArray.push({'text': i.name, 'value': i})
            })
            if (data.isLast === true) {
              projectLookup[globalProjectId] = globalProject
              commit('setProjects', projectLookup)
              projectsArray.unshift({text: globalProjectName, value: globalProject})
              projectsArray.unshift({text: 'Select a project', value: null, disabled: true})
              commit('setProjectsArray', projectsArray)
            } else {
              getProjectData(startAt + maxResults, maxResults)
            }
          },
          error: (response) => {
            Sentry.captureMessage(response)
          }
        })
      }
      if (typeof window.AP !== 'undefined') {
        getProjectData()
      } else {
        setTimeout(getProjectData, 250)
      }
    },
    setCurrentProject ({ commit, state }, projectId) {
      // This one is reached when the project is set via the dropdown, when the projects list hasn't been retrieved yet
      // TODO - combine this code with the code for refreshProject, because it's 99% similar
      if (Object.keys(state.projects).length === 0) {
        const globalProjectId = 0
        const globalProjectName = 'Global Requirements'
        const globalProject = {id: globalProjectId, name: globalProjectName}
        const projectLookup = {}
        const projectsArray = []
        const getProjectData = (startAt = 0, maxResults = 50) => {
          window.AP.request({
            url: `/rest/api/3/project/search?startAt=${startAt}&maxResults=${maxResults}`,
            success: response => {
              const data = JSON.parse(response)
              data.values.forEach(i => {
                projectLookup[i.id] = i
                projectsArray.push({'text': i.name, 'value': i})
              })
              if (data.isLast === true) {
                projectLookup[globalProjectId] = globalProject
                commit('setProjects', projectLookup)
                const projectObj = projectLookup[projectId.toString()]
                commit('setCurrentProject', projectObj)
                projectsArray.unshift({text: globalProjectName, value: globalProject})
                projectsArray.unshift({text: 'Select a project', value: null, disabled: true})
                commit('setProjectsArray', projectsArray)
              } else {
                getProjectData(startAt + maxResults, maxResults)
              }
            },
            error: (response) => {
              Sentry.captureMessage(response)
            }
          })
        }
        if (typeof window.AP !== 'undefined') {
          getProjectData()
        } else {
          setTimeout(getProjectData, 250)
        }
      } else {
        const projectObj = state.projects[projectId.toString()]
        commit('setCurrentProject', projectObj)
      }
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js